'use strict';
module.exports = require('../../full/url-search-params');



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/features/url-search-params/index.js
// module id = 617
// module chunks = 13